import { uiText, useUiLanguage } from '../utils/uiTranslation';
import React, { useEffect, useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import './AcceptTeamInvite.css';

const AcceptTeamInvite = () => {
  useUiLanguage();
  const [loading, setLoading] = useState(true);
  const [invalid, setInvalid] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [processing, setProcessing] = useState(false);

  // Extract slug from query
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const slug = params.get('invite');
    if (!slug) {
      setInvalid(true);
      setLoading(false);
      return;
    }

    // Verify invite
    fetch('https://us-central1-jobseeqr.cloudfunctions.net/verify_invite', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ slug })
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          setCompanyName(result.companyName);
          setEmail(result.email);
        } else {
          setInvalid(true);
        }
      })
      .catch((err) => {
        console.error('Error verifying invite:', err);
        setInvalid(true);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSignUp = () => {
    const params = new URLSearchParams(window.location.search);
    const slug = params.get('invite');
    if (!slug) return;
    
    if (!firstName.trim() || !lastName.trim()) {
      alert(uiText('Please enter your first and last name.'));
      return;
    }

    const fullName = `${firstName.trim()} ${lastName.trim()}`.trim();
    
    setProcessing(true);

    fetch('https://us-central1-jobseeqr.cloudfunctions.net/accept_invite', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        slug,
        username: email,
        password,
        fullName,
        firstName: firstName.trim(),
        lastName: lastName.trim()
      })
    })
      .then((res) => res.json())
      .then(async (result) => {
        if (result.success) {
          try {
            await signInWithEmailAndPassword(auth, email, password);
            // Redirect to app root so the new user lands in the main dashboard
            window.location.href = '/';
          } catch (error) {
            if (error.code === 'auth/user-not-found') {
              alert(uiText('The username entered does not exist.'));
            } else if (error.code === 'auth/wrong-password') {
              alert(uiText('Password for this account is incorrect.'));
            } else {
              alert(error.message);
            }
          }
        } else {
          alert(result.error || 'Failed to create account.');
        }
      })
      .catch((err) => {
        console.error('Error calling accept_invite:', err);
        alert(uiText('Failed to create account.'));
      })
      .finally(() => setProcessing(false));
  };

  if (loading) {
    return (
      <div id="loading-screen">
        <i className="fa-solid fa-spinner fa-spin" style={{ color: '#568ded', fontSize: '40px' }}></i>
        <p>{uiText("Please Wait")}</p>
      </div>
    );
  }

  if (invalid) {
    return (
      <div id="invalid-link">
        <p className="hdr">{uiText("Invalid Invite Link")}</p>
        <p>{uiText("Please contact your administrator to re-invite you to the workspace.")}</p>
      </div>
    );
  }

  return (
    <div id="team-sign-up" className="team-invite-screen">
      <div className="team-invite-card">
        <div className="team-invite-badge">{uiText("Team Invite")}</div>
        <p id="team-name" className="hdr">{companyName}{uiText("&apos;s JOBSEEQR Workspace")}</p>
        <p className="team-invite-subtitle">{uiText("Create your login to join the shared workspace.")}</p>

        <div className="team-invite-grid">
          <input
            id="first-name-collab"
            placeholder={uiText("First Name")}
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <input
            id="last-name-collab"
            placeholder={uiText("Last Name")}
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>
        <input
          id="email-addr-collab"
          placeholder={uiText("Email address")}
          value={email}
          readOnly
        />
        <input
          id="pass-collab"
          type="password"
          placeholder={uiText("Password")}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div className="action-btn-container">
          <button onClick={handleSignUp} disabled={processing} className="team-invite-submit">
            {processing ? uiText("Creating...") : (
              <span>{uiText("Join Workspace ")}<i className="fa-solid fa-arrow-right" style={{ marginLeft: '10px' }}></i>
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcceptTeamInvite;
